import React, { FC, useMemo } from 'react'
import { NxAlert } from '../../../components/alert'
import { AlertContainer } from './styles/MaintenanceAlert.styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'

const MaintenanceAlert: FC = (): React.ReactElement => {
  const mfeManifests = useSelector((state: RootState) => state.mfe.manifests)
  const hasAnyUnavailableMfe = useMemo(
    (): boolean => mfeManifests.some((m) => !m.loaded),
    [mfeManifests],
  )

  return (
    <AlertContainer>
      {hasAnyUnavailableMfe && (
        <NxAlert
          type='warning'
          title='Algumas funcionalidades estão indisponíveis'
          description='Estamos trabalhando para resolver o mais breve possível.'
        />
      )}
    </AlertContainer>
  )
}

export default MaintenanceAlert
